import { Availability, ChaletNameEnum } from "./availability.model";
import { Booking, BookingTypeEnum } from "./booking.model";
import { Step1 } from "./cards";
import { dateToString, moneyToString, scrollToTop, setStepQS, Variables } from "./common";
import { RoomBooking, RoomBookingStatusEnum } from "./room-booking.model";
import { Step3 } from "./step3";

/**
 * Using singleton design pattern
 */
export class Step2 {

    private static _instance: Step2;

    /**
     * The Singleton's constructor should always be private to prevent direct
     * construction calls with the `new` operator.
     */
    private constructor() {

        // disable back button, and anything else that causes leaving booking
        //disableBackButton();

        this.handleStartOverButton();
        this.handleNextButton();

        // register an action for when an li which contains the booking type option is clicked
        this.handleBookingTypeSelection();

        this.handleExtraRoomSelection();

        this.handleRoomBookingsSelection();
    }




    /**
     * The static method that controls the access to the singleton instance.
     *
     * This implementation let you subclass the Singleton class while keeping
     * just one instance of each subclass around.
     */
    public static get instance(): Step2 {
        if (!Step2._instance) {
            Step2._instance = new Step2();
        }

        return Step2._instance;
    }



    private stepId = "bookingStep2";
    private bookingSizeSelectionListId = "ulBookingSizeSelectionList";
    private roomingAndGuestSelectionId = "roomingAndGuestSelection";
    private pricingNotesId = "pricingNotes";
    private calculatedPriceId = "calculatedPrice";
    private btnStep2To3Id = "btnStep2To3";

    /**
     * hide : hides step 2
     */
    public hide() {
        Variables.$(`#${this.stepId}`).removeClass("active");
    }

    /**
     * show : shows step 2
     */
    public show() {
        Variables.$(`#${this.stepId}`).addClass("active");
        scrollToTop(this.stepId);
        setStepQS('step2');
    }


    private $bookingTypeRadio = Variables.$("input:radio[name=bookingSizeSelection]");



    public clickStartOverButton() {
        this.hide();
        Step1.instance.show();
    }
    public clickNextButton() {
        if (!this.booking?.finalPrice) { // proceed to the next step if the final price is calculated
            return false;
        }
        Step3.instance.setBooking(this.booking);
        this.hide();
        Step3.instance.show();
    }

    private handleStartOverButton = () => {
        Variables.$(`#${this.stepId} #btnStartOver`).click(() => {
            this.clickStartOverButton();
        });
    }
    private handleNextButton = () => {
        Variables.$(`#${this.stepId} #${this.btnStep2To3Id}`).click((event) => {
            this.clickNextButton();
        });
    }

    private handleBookingTypeSelection = () => {
        Variables.$(`#${this.stepId} #bookingType #${this.bookingSizeSelectionListId} li`).click((event) => {
            let $li = Variables.$(event.currentTarget);

            // remove the selection which was selected before
            $li.siblings("li").removeClass("selected");

            // if the previous selected option is not the same as the current clicked item, now select it and update UI
            if (!$li.hasClass("selected")) {
                $li.addClass("selected");

                // set the checked attr for the radio inside li
                this.$bookingTypeRadio.filter(":checked").prop("checked", false);

                // fire the event that the radio checked
                $li.find("input").prop("checked", true).change();

                this.updateUI();
            }

            return false; // this stops propagation
        });

    }

    private handleExtraRoomSelection() {
        Variables.$("select#extraRooms").change((event) => {
            this.updateUI();
        });
    }

    private handleRoomBookingsSelection = () => {

        // guestAges is inside Li
        // we want to check/uncheck Li by user click
        // however when the click is inside guestAges we don't want this
        // the reason is that in guestAge there are some drop downs, and clicking on them should not affect Li selection
        // so in this event handler below, we only say if guestAge area clicked do not bubble  event up
        Variables.$(`#${this.stepId} #${this.roomingAndGuestSelectionId} li .guestAges`).click((event) => {
            return false; // this stops propagation
        });



        Variables.$(`#${this.stepId} #${this.roomingAndGuestSelectionId} li`).click((event) => {
            let $li = Variables.$(event.currentTarget);

            // ignore check box click if it is unavailable, as it is not selectable
            if ($li.hasClass("unavailable")) {
                return false;
            }

            // if the previous selected option is not the same as the current clicked item, now select it and update UI
            if (!$li.hasClass("selected")) {
                $li.addClass("selected");

                // fire the event that the checkbox checked
                $li.find("input").prop("checked", true).change();

            } else {
                $li.removeClass("selected");

                // fire the event that the checkbox checked
                $li.find("input").prop("checked", false).change();
            }

            this.updateUI();

            return false; // this stops propagation
        });


        Variables.$(`#${this.stepId} #${this.roomingAndGuestSelectionId} li .guestAges select`).change(() => {
            this.updateUI();
        });

    }




    /**
     * setAvailability
     */
    public setAvailability(availability: Availability) {
        this.booking = new Booking(availability);

        this.setupBookingSummary();

        this.updateUI();
    }


    private booking: Booking

    private updateUI() {

        this.setupBookingType();

        this.setupRoomingExtra();

        this.setupRoomBookings();

        this.setupPricingNotes();

        this.setupPrice()

        this.updateNextButtonUI();

        this.setupSummaryMessage();

    }





    private setupBookingSummary() {
        const $bookingSummary = Variables.$(`#${this.stepId} #bookingSummary`);

        // setting up the property name from the data attribute
        const $propertyName = $bookingSummary.find('#spnPropertyName');
        $propertyName.text($propertyName.data(`title-${this.booking.availability.name.toLowerCase()}`));

        // setting arrival date
        $bookingSummary.find('#spnArrivalDate').text(dateToString(this.booking.availability.arrivalDate, true));

        // setting departure date
        $bookingSummary.find('#endDateText').text(dateToString(this.booking.availability.departureDate, true));

        // setting duration
        $bookingSummary.find('#spnStayDurationInNights').text(`${this.booking.availability.duration} Nights`);
    }




    private setupBookingType() {

        const $bookingTypeDiv = Variables.$(`#${this.stepId} #bookingType`);

        if (!this.booking.availability.isPricePerPerson || // can't book partially ==> only whole chalet
            !this.booking.availability.roomsBooked?.length // there is no data about booking of rooms ==> only whole chalet
        ) {
            $bookingTypeDiv.hide();
            this.booking.bookingType = BookingTypeEnum.ExclusiveBooking;
            return;
        }


        if (this.booking.availability.roomsBooked.indexOf(true) !== -1 // there is some rooms already booked,  ==> only partial booking available
        ) {
            $bookingTypeDiv.hide();
            this.booking.bookingType = BookingTypeEnum.PartialBooking;
            return;
        }


        // both whole chalet and partial booking options are available
        $bookingTypeDiv.show();

        // now we show booking type div, so we need to look at UI to set booking type
        // the id of radio options are the same as booking type enum values
        this.booking.bookingType = this.$bookingTypeRadio.filter(":checked").attr('id');


    }

    private setupRoomingExtra() {

        const $roomingExtraDiv = Variables.$(`#${this.stepId} #optionalRoomingExtras`);

        if (this.booking.availability.name !== ChaletNameEnum.PetitePia || this.booking.bookingType === BookingTypeEnum.PartialBooking) {
            this.booking.annexRooms = null;
            $roomingExtraDiv.hide();
            return;
        }


        const $dropdown = $roomingExtraDiv.find('select');
        const annexRoomPrice = Number($dropdown.val());
        const $annexSelectedOption = $dropdown.find(":selected");


        // the value of the selected item in the dropdown shows the price for annex room, this values coming from site wide variables
        this.booking.annexRooms = {
            maxPax: $annexSelectedOption.data('max-pax'),
            price: annexRoomPrice,
            roomsNumber: $annexSelectedOption.data('rooms-number')
        }

        $roomingExtraDiv.show();
    }



    private get roomBookingIsAvailable(): boolean {
        return this.booking.availability.isPricePerPerson && // can book partially and
            this.booking.bookingType == BookingTypeEnum.PartialBooking // user selected to book partially above
            ;
    }


    private setupRoomBookings() {

        const $roomBookingDiv = Variables.$(`#${this.stepId} #${this.roomingAndGuestSelectionId}`);

        if (!this.roomBookingIsAvailable) {
            $roomBookingDiv.hide();
            this.booking.roomsBooking = null;
            return;
        }

        $roomBookingDiv.show();

        this.booking.roomsBooking = [];

        $roomBookingDiv.find('ul').hide();// all room booking for all chalets
        const $roomBookingUl = $roomBookingDiv.find(`ul#${this.booking.availability.name}BedroomOptionsList`).show(); // show the room booking for this chalet

        $roomBookingUl.find('li').
            each((index, element) => {
                const $li = Variables.$(element);
                const roomBooking = new RoomBooking();
                this.booking.roomsBooking.push(roomBooking);

                roomBooking.maxPax = $li.data('max-pax');
                roomBooking.singleRoomSupplementFactor = $li.data('single-room-supplement');
                roomBooking.thirdGuestOnwardDiscountFactor = $li.data('third-guest-discount-factor');
                roomBooking.childDiscount = $li.data('child-discount');
                roomBooking.babyPrice = $li.data('baby-price');
                roomBooking.extraPriceForThisRoom = $li.data('extra-price-for-this-room');
                roomBooking.aptDiscountPerPerson = $li.data('apt-discount-per-person');
                roomBooking.aptMinPax = $li.data('apt-min-pax');



                // find dropdown which had id starting with "numberOfAdultsIn"
                roomBooking.adultsNumber = Number($li.find("select[id^='numberOfAdultsIn']").val());

                // find dropdown which had id starting with "numberOfChildrenIn"
                roomBooking.childrenNumber = Number($li.find("select[id^='numberOfChildrenIn']").val());

                // find dropdown which had id starting with "numberOfBabiesIn"
                roomBooking.babiesNumber = Number($li.find("select[id^='numberOfBabiesIn']").val());



                if (this.booking.availability.roomsBooked[index]) { // the room is not available
                    $li.removeClass('selected').removeClass('validationError').addClass('unavailable');
                    roomBooking.status = RoomBookingStatusEnum.Unavailable;
                    return;
                }

                // the room is available, so remove the class if it exists there
                $li.removeClass('unavailable');

                if (!$li.hasClass('selected')) { // the room is not selected by user
                    $li.removeClass('validationError');
                    roomBooking.status = RoomBookingStatusEnum.Unselected;
                    return;
                }


                // if we reach to this point it means the user selected the room, now we need to check if it is valid

                if (
                    roomBooking.adultsNumber + roomBooking.childrenNumber > roomBooking.maxPax //  the combined total number of adults and children exceeds the number of bed spaces
                ) {
                    $li.addClass('validationError'); // it is selected but invalid
                    roomBooking.status = RoomBookingStatusEnum.InvalidAsTooManyGuests;
                } else if (roomBooking.adultsNumber + roomBooking.childrenNumber === 0) { // there is no guest in the room
                    $li.addClass('validationError'); // it is selected but invalid
                    roomBooking.status = RoomBookingStatusEnum.InvalidAsNoGuest;
                } else if (roomBooking.aptMinPax && roomBooking.adultsNumber + roomBooking.childrenNumber < roomBooking.aptMinPax) { // no enough guests for apt.
                    $li.addClass('validationError'); // it is selected but invalid
                    roomBooking.status = RoomBookingStatusEnum.InvalidAsNoEnoughGuestForApt;
                }
                else {
                    $li.removeClass('validationError'); // it is selected with no validation error
                    roomBooking.status = RoomBookingStatusEnum.Selected;
                }
            });



    }


    private setupPricingNotes() {
        const $pricingNotesDiv = Variables.$(`#${this.stepId} #${this.pricingNotesId}`);
        // by default hide it, if any message needed to appear, we show that.
        $pricingNotesDiv.hide();

        if (!this.roomBookingIsAvailable || !this.booking.roomsBooking?.length) { // there is no room booking, i.e., partial booking
            return;
        }

        if (this.booking.roomsBooking.some(rmb => rmb.status === RoomBookingStatusEnum.InvalidAsTooManyGuests)) { // if there is a room with PAX error
            $pricingNotesDiv.show().find('#spnPaxErrorMessage').show();
        } else {
            $pricingNotesDiv.find('#spnPaxErrorMessage').hide();
        }

        if (this.booking.roomsBooking.some(rmb => rmb.status === RoomBookingStatusEnum.InvalidAsNoGuest)) { // if there is a room with no (non-baby) guest
            $pricingNotesDiv.show().find('#spnZeroPaxErrorMessage').show();
        } else {
            $pricingNotesDiv.find('#spnZeroPaxErrorMessage').hide();
        }

        if (this.booking.roomsBooking.some(rmb => rmb.status === RoomBookingStatusEnum.InvalidAsNoEnoughGuestForApt)) { // if apartment does not have enough (non-baby) guest
            $pricingNotesDiv.show().find('#spnApartmentMinPaxErrorMessage').show();
        } else {
            $pricingNotesDiv.find('#spnApartmentMinPaxErrorMessage').hide();
        }

        // for the messages below we only look at the selected rooms to book
        const $selectedRoomBookings = this.booking.roomsBooking.filter(rmb => rmb.status === RoomBookingStatusEnum.Selected);

        if ($selectedRoomBookings.some(rmb => rmb.adultsNumber < 2 && rmb.childrenNumber > 0 && rmb.thirdGuestOnwardDiscountFactor)) { // if there is a room with a child within the first two guests
            $pricingNotesDiv.show().find('#spnChildDiscountMessage').show();
        } else {
            $pricingNotesDiv.find('#spnChildDiscountMessage').hide();
        }

        if ($selectedRoomBookings.some(rmb => !rmb.thirdGuestOnwardDiscountFactor && rmb.childrenNumber > 0)) { // if there is a room with a child within && the third guest discount is not applicable
            $pricingNotesDiv.show().find('#spnChildDiscountNotHavingThirdGuestDiscountMessage').show();
        } else {
            $pricingNotesDiv.find('#spnChildDiscountNotHavingThirdGuestDiscountMessage').hide();
        }

        if ($selectedRoomBookings.some(rmb => rmb.babiesNumber > 0)) { // if there are some rooms with babies in
            $pricingNotesDiv.show().find('#spnBabyFeeMessage').show();
        } else {
            $pricingNotesDiv.find('#spnBabyFeeMessage').hide();
        }

        if ($selectedRoomBookings.some(rmb => rmb.adultsNumber + rmb.childrenNumber === 1 && rmb.singleRoomSupplementFactor)) { // if there is a room with single supplement
            $pricingNotesDiv.show().find('#spnSingleSupplementMessage').show();
        } else {
            $pricingNotesDiv.find('#spnSingleSupplementMessage').hide();
        }

        if ($selectedRoomBookings.some(rmb => rmb.extraPriceForThisRoom)) { // if there is a room with extra price for premium room
            $pricingNotesDiv.show().find('#spnMasterBedroomSupplementMessage').show();
        } else {
            $pricingNotesDiv.find('#spnMasterBedroomSupplementMessage').hide();
        }

        if ($selectedRoomBookings.some(rmb => rmb.adultsNumber + rmb.childrenNumber > 2 && rmb.thirdGuestOnwardDiscountFactor)) { // if there is a room with more than 2 (non-baby) guests
            $pricingNotesDiv.show().find('#spnHalfPriceThirdGuestInBedroom').show();
        } else {
            $pricingNotesDiv.find('#spnHalfPriceThirdGuestInBedroom').hide();
        }

        if ($selectedRoomBookings.some(rmb => rmb.aptDiscountPerPerson)) { // if there is an apartment discount
            $pricingNotesDiv.show().find('#spnDiscountForAptBooking').show();
        } else {
            $pricingNotesDiv.find('#spnDiscountForAptBooking').hide();
        }
    }



    private setupPrice() {
        // we initially set price to zero, to make calculation for plus operator easier. We may set it back to null later
        this.booking.finalPrice = 0;
        if (this.booking.bookingType === BookingTypeEnum.ExclusiveBooking) {
            this.calculatePriceForWholeChaletBooking();
        } else { // booking is partial for rooms
            this.calculatePriceForPartialBooking();
        }

        const $calculatedPriceDiv = Variables.$(`#${this.stepId} #${this.calculatedPriceId}`);
        if (!this.booking.finalPrice) { // calculated price is null or 0
            $calculatedPriceDiv.hide();
        } else {
            $calculatedPriceDiv.text(
                moneyToString(this.booking.finalPrice, true)
            );
            $calculatedPriceDiv.show();
        }

    }




    private calculatePriceForPartialBooking() {
        var selectedRooms = this.booking.roomsBooking.filter(rm => rm.status === RoomBookingStatusEnum.Selected);

        if (selectedRooms.length === 0 ||
            this.booking.roomsBooking.some(rm => rm.status === RoomBookingStatusEnum.InvalidAsTooManyGuests) ||
            this.booking.roomsBooking.some(rm => rm.status === RoomBookingStatusEnum.InvalidAsNoGuest) ||
            this.booking.roomsBooking.some(rm => rm.status === RoomBookingStatusEnum.InvalidAsNoEnoughGuestForApt)
        ) { // there is no selected room, or some rooms are invalid
            this.booking.finalPrice = null;
            return;
        }

        selectedRooms.forEach(roomBooking => {
            roomBooking.calculatedPrice = 0;

            if (roomBooking.thirdGuestOnwardDiscountFactor) {

                const adultAndChild = roomBooking.adultsNumber + roomBooking.childrenNumber;
                const adultBeforeThirdGuest = Math.min(roomBooking.adultsNumber, 2);
                const childBeforeThirdGuest = 2 - adultBeforeThirdGuest;// from the first 2 guests how many children?
                const guestFromThirdGuestOnward = Math.max(adultAndChild - 2, 0);

                // for adults before 3 guests, consider full price
                roomBooking.calculatedPrice += adultBeforeThirdGuest * this.booking.availability.currentPrice;

                // for children before 3 guests, consider child discount
                roomBooking.calculatedPrice += childBeforeThirdGuest * (this.booking.availability.currentPrice - roomBooking.childDiscount);


                // for any guest (not babies) from third onward consider third guest discount
                roomBooking.calculatedPrice += guestFromThirdGuestOnward * (roomBooking.thirdGuestOnwardDiscountFactor * this.booking.availability.currentPrice);

            } else {
                // for adults consider full price
                roomBooking.calculatedPrice += roomBooking.adultsNumber * this.booking.availability.currentPrice;

                // for children consider child discount
                roomBooking.calculatedPrice += roomBooking.childrenNumber * (this.booking.availability.currentPrice - roomBooking.childDiscount);
            }




            if (roomBooking.singleRoomSupplementFactor) {

                if (roomBooking.adultsNumber === 1 && !roomBooking.childrenNumber) { // only one person in the room who is an adult
                    roomBooking.calculatedPrice += (roomBooking.singleRoomSupplementFactor - 1) * this.booking.availability.currentPrice;
                } else if (!roomBooking.adultsNumber && roomBooking.childrenNumber === 1) { // only one person in the room who is a child
                    roomBooking.calculatedPrice += (roomBooking.singleRoomSupplementFactor - 1) * (this.booking.availability.currentPrice - roomBooking.childDiscount);
                }
            }


            if (roomBooking.babiesNumber) {
                roomBooking.calculatedPrice += roomBooking.babiesNumber * roomBooking.babyPrice;
            }

            if (roomBooking.extraPriceForThisRoom) {
                roomBooking.calculatedPrice += roomBooking.extraPriceForThisRoom;
            }

            if (roomBooking.aptDiscountPerPerson) {
                roomBooking.calculatedPrice -= roomBooking.aptDiscountPerPerson * (roomBooking.adultsNumber + roomBooking.childrenNumber);
            }

            this.booking.finalPrice += roomBooking.calculatedPrice;

        });

    }

    private calculatePriceForWholeChaletBooking() {

        if (this.booking.availability.isPricePerPerson) {
            this.booking.finalPrice = this.booking.availability.currentPrice * this.booking.availability.minPax;
        } else {
            this.booking.finalPrice = this.booking.availability.currentPrice;
        }

        if (this.booking.annexRooms) {
            this.booking.finalPrice += this.booking.annexRooms.price;
        }
    }

    private updateNextButtonUI() {
        const $nextButtonParent = Variables.$(`#${this.stepId} #${this.btnStep2To3Id}`).closest('div');
        if (this.booking.finalPrice) {
            $nextButtonParent.removeClass('forbidden');
        } else {
            $nextButtonParent.addClass('forbidden');
        }
    }

    private setupSummaryMessage() {

        if (this.booking.bookingType === BookingTypeEnum.ExclusiveBooking &&
            this.booking.annexRooms == null &&
            this.booking.roomsBooking == null) {
            Variables.$(`#${this.stepId} #pCanAdjustPrice`).hide();
            Variables.$(`#${this.stepId} #pCannotAdjustPrice`).show();
        } else {
            Variables.$(`#${this.stepId} #pCanAdjustPrice`).show();
            Variables.$(`#${this.stepId} #pCannotAdjustPrice`).hide();
        }
    }

    public findRoom(roomIndex: number, chaletName: ChaletNameEnum): { name: string, abbreviation: string } {
        const $roomLi = Variables.$(`#${this.stepId} #${this.roomingAndGuestSelectionId} ul#${chaletName}BedroomOptionsList li`).eq(roomIndex);
        return { abbreviation: $roomLi.data('room-abbv-name'), name: $roomLi.data('room-name') }
    }
}
